export const DESCRIPTION_FORMATS = `
  query descriptionFormats($filter: FilterDescriptionFormatInput) {
    descriptionFormats(filter: $filter) {
      __typename
      ... on DescriptionFormat {
        id
        code
        description
        visible
      }
    }
  }
`;
